import React from "react";
import { Link } from "react-router-dom";

export const Tipos = () => {
  return (
    <div className="container">
      <div className="mb-5 px-3 pb-5 mt-3">
        <section className="container ">
          <div className="d-flex justify-content-between">
            <p className="p">Canal de Ouvidoria do 1RIGO</p>
            <a className="btn btn-outline-warning" href="../">
              Voltar
            </a>
          </div>
          <div className="mb-3">
            <p>
              Para realizar uma manifestação, por favor, escolha uma das opções
              abaixo:
            </p>
          </div>
        </section>
        <section className="container denuncias-index denuncias-ouvidoria">
          <div>
            <Link to="/tipos/elogios">
              <i className="bi bi-chat-right-quote"></i>
              <p>Elogios</p>
            </Link>
          </div>
          <div>
            <Link to="/tipos/sugestoes">
              <i className="bi bi-chat-right-quote"></i>
              <p>Sugestões</p>
            </Link>
          </div>
          <div>
            <Link to="/tipos/reclamacoes">
              <i className="bi bi-chat-right-quote"></i>
              <p>Reclamações</p>
            </Link>
          </div>
          {/*<div>
            <a href="http://canaldedenuncias.1rigo.com/">
              <i className="bi bi-chat-right-quote"></i>
              <p>Denúncia</p>
            </a>
          </div>*/}
        </section>
      </div>
    </div>
  );
};
